//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import Scroller from '~/components/global/Scroller'
import { getCabinCharterPageInformation } from '~/utils/server'
import CheckCircle from '~/static/assets/icons/fa/check-circle.svg'
import FaqItems from '~/components/Flotillas/FaqItems'
import vRating from '~/components/v/rating.vue'
import pageMeta, { mxGetMeta } from '~/mixins/pageMeta'
import flotilla from '~/mixins/page/flotilla'
import { getFlag } from '~/utils/languages'
import { Breadcrumbs } from '~/plugins/breadcrumbs'
import RequestBoatModal from '~/components/modal/boat/request-boat-modal'
import RequestOfferForm from '~/components/form/user/request-offer-form'
import { asyncDataCatch, asyncDataStart } from '~/utils/asyncData'
import { isObject } from '~/utils/v'

export default {
  name: 'cabincharter',
  components: {
    Scroller,
    CheckCircle,
    FaqItems,
    vRating,
    RequestBoatModal,
    RequestOfferForm
  },
  filters: {
    formattedDate (inDate, inFormat, outFormat) {
      const t = inDate.split('-')
      if (t.length === 3) {
        return t[2] + '/' + t[1] + '/' + t[0]
      } else {
        return inDate
      }
    },
    resizeImageUrl (url, width, height, options = {}) {
      let result = `${url}`
      if (result.match(/&w=\d*/)) {
        result = result.replace(/&w=\d*/, `&w=${width}`)
      } else {
        result += `&w=${width}`
      }
      if (result.match(/&h=\d*/)) {
        result = result.replace(/&h=\d*/, `&h=${height}`)
      } else {
        result += `&h=${height}`
      }

      if (isObject(options)) {
        for (const [key, value] of Object.entries(options)) {
          result += `&${key}=${value}`
        }
      }
      result = result.replace(/&rect=(\d+(,\d+)*)/, '')
      return result
    }
  },
  mixins: [pageMeta, flotilla],
  async asyncData (ctx) {
    await asyncDataStart(ctx)

    try {
      const crubms = Breadcrumbs.get(ctx.app.i18n, 'page', ctx.route, [{
        title: ctx.app.i18n.t('cabin-charter'),
        url: ctx.route.fullPath
      }])
      await ctx.store.dispatch('setBreadcrumbs', crubms)

      const ietfLocale = ctx.store.getters['lang/currentLanguage']?.ietf_locale
      const lang = ctx.store.getters['lang/locale']
      const ietf = lang === 'us' ? 'en-gb' : ietfLocale || 'en-gb'

      await mxGetMeta(ctx, {
        meta: {
          idx: ctx.route.params.country || 'empty',
          method: 'dynamic',
          type: ctx.route.params.location ? 'cabincharter' : 'cabincharter',
          path: ctx.route.path
        }
      })
      const pageInformation = await getCabinCharterPageInformation(ctx, { lang: lang === 'us' ? 'en' : lang, ietf })
      if (Object.keys(pageInformation).length === 0) {
        ctx.redirect(301, ctx.app.router.resolve({ name: 'cabincharter', params: {lang: 'en'} }).href)
        return
      }

      return { pageInformation }
    } catch (e) {
      return asyncDataCatch(ctx, e)
    }
  },
  computed: {
    ...mapState({
      pageSeoData: state => state.pageData,
      lang: state => state.lang.locale
    }),
    getSliderSettings: app => (name) => {
      const SETTINGS = {
        reviews: {
          slidesToShow: 1,
          arrows: false,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
                dots: true,
                arrows: false
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                dots: false,
                arrows: true
              }
            }
          ]
        }
      }
      return {
        ...SETTINGS[name]
      }
    }
  },
  data () {
    return {
      page: {
        sticky: false
      }
    }
  },
  methods: {
    getFlag (name) {
      return getFlag(name)
    },
    setSticky (isVisible, entry) {
      this.page.sticky = !isVisible
    },
    scrollToElement ($element) {
      const offset = 100
      const bodyRect = document.body.getBoundingClientRect().top
      const elementRect = document.getElementById($element).getBoundingClientRect().top
      const elementPosition = elementRect - bodyRect
      const offsetPosition = elementPosition - offset

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })
    }
  },
  beforeDestroy () {
    this.$store.dispatch('removeMetaHead', { type: 'meta', idxParam: 'name', idx: 'twitter:image' })
    this.$store.dispatch('removeMetaHead', { type: 'meta', idxParam: 'property', idx: 'og:image' })
  }
}
